<div class="buffer">
    <form class="k-form-inline" *ngIf="!buffering">
        <label *ngIf="warningMsg" class="k-form-field">
            <p class="alert alert-red is-active">
                <strong>Warning:&nbsp;</strong>{{ warningMsg }}
            </p>
        </label>
        <label class="k-form-field" *ngIf="showSettings.type">
            <span>Buffer Type:</span>
            <span>
                <input type="radio" name="group" id="singleBufferRadio" class="k-radio" [(ngModel)]="multiBuffer" value="false" (change)="checkFilteredLayerWarning()" checked />
                <span for="singleBufferRadio">Single</span>
            </span>
            <span>
                <input type="radio" name="group" id="multiBufferRadio" [(ngModel)]="multiBuffer" value="true" class="k-radio" />
                <span for="multiBufferRadio" class="buffer-radio-multi">Multiple</span>
            </span>
        </label>
        <label class="k-form-field" *ngIf="(multiBuffer !== 'true') && showSettings.distance">
            <span>Buffer Distance:</span>
            <input class="k-textbox" type="number" placeholder="Choose distance" [(ngModel)]="bufferDistance" name="distance" />
        </label>
        <label class="k-form-field" *ngIf="(multiBuffer === 'true') && showSettings.distance">
            <span>Buffer Distance:</span>
            <input class="k-textbox" type="text" placeholder="Choose distance" [(ngModel)]="bufferDistance" name="multidistance" (change)="checkFilteredLayerWarning()" />
        </label>
        <label class="k-form-field" *ngIf="(multiBuffer === 'true') && showSettings.distance">
            <div>Enter comma separated numbers for multiple buffers.</div>
        </label>
        <label class="k-form-field" *ngIf="showSettings.distanceUnit">
            <span>Buffer Distance Units:</span>
            <kendo-dropdownlist [data]="distanceUnits" [textField]="'name'" [valueField]="'value'" [valuePrimitive]="true" [(ngModel)]="bufferOptions.distanceUnit" name="distanceUnit" [popupSettings]="{appendTo:'component'}"></kendo-dropdownlist>
        </label>
        <label class="k-form-field" *ngIf="showSettings.areaUnit">
            <span>Buffer Area Unit:</span>
            <kendo-dropdownlist [data]="areaUnits" [textField]="'name'" [valueField]="'value'" [valuePrimitive]="true" [(ngModel)]="bufferOptions.areaUnit" name="areaUnit" [popupSettings]="{appendTo:'component'}"></kendo-dropdownlist>
        </label>
        <label class="k-form-field" *ngIf="showSettings.fillType">
            <span>Fill Type:</span>
            <kendo-dropdownlist [data]="fillTypes" [textField]="'name'" [valueField]="'value'" [valuePrimitive]="true" [(ngModel)]="bufferOptions.fillType" name="fillType" [popupSettings]="{appendTo:'component'}"></kendo-dropdownlist>
        </label>
        <label class="k-form-field" *ngIf="showSettings.fillColor">
            <span>Fill Color:</span>
            <mc-color-picker-ng #fillColorPicker [(color)]="bufferOptions.fillColor" [siblingColorPickers]="[outlineColorPicker]"></mc-color-picker-ng>
        </label>
        <label class="k-form-field" *ngIf="showSettings.outlineType">
            <span>Outline Type:</span>
            <kendo-dropdownlist [data]="outlineTypes" [textField]="'name'" [valueField]="'value'" [valuePrimitive]="true" [(ngModel)]="bufferOptions.outlineType" name="outlineType" [popupSettings]="{appendTo:'component'}"></kendo-dropdownlist>
        </label>
        <label class="k-form-field" *ngIf="showSettings.outlineColor">
            <span>Outline Color:</span>
            <mc-color-picker-ng #outlineColorPicker [(color)]="bufferOptions.outlineColor" [siblingColorPickers]="[fillColorPicker]"></mc-color-picker-ng>
        </label>
        <label *ngIf="bufferableLayers && bufferableLayers.length>0" class="k-form-field">
            <span>Layers:</span>
            <kendo-multiselect #buffertest [listHeight]=100 [data]="bufferableLayers" [placeholder]="'Optional layers to filter by new buffer'"
                               [valuePrimitive]="false" [textField]="'mapcoreProps.name'" [valueField]="'id'" name="bufferableLayers"
                               [filterable]="true" [popupSettings]="{popupClass: 'test',height:50,appendTo:'component'}"
                               [(ngModel)]="selectedLayers" (valueChange)="checkFilteredLayerWarning()">
                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                    {{ dataItem.name || dataItem.mapcoreProps.name }}
                </ng-template>
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                    {{ dataItem.name || dataItem.mapcoreProps.name }}
                </ng-template>
            </kendo-multiselect>
        </label>
        <label *ngIf="warningMsg" class="k-form-field">
            <p class="alert alert-red is-active">
                <strong>Warning:&nbsp;</strong>{{ warningMsg }}
            </p>
        </label>
        <button class="btn btn-small" *ngIf="!(options && (options.showContinueButton === false || options.showContinueButton === 'false'))" (click)="buffer()">Continue</button>
    </form>

    <div *ngIf="buffering">
        <div class="loader is-active padding-leader-3 padding-trailer-3">
            <div class="loader-bars"></div>
            <div class="loader-text">Loading...</div>
        </div>
    </div>
</div>
